import { useEffect, useState, useCallback } from "react";
import dayjs from "@/lib/day";
import styles from "@/styles/Video.module.scss";
import { Button } from "@/components/Buttons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const formatCountDown = function (diff) {
  if (diff > 0) {
    if (diff >= 86400) {
      return `${Math.floor(diff / 86400)}日`;
    }
    let format = "H時間";
    if (diff < 3600) {
      format = "m分";
    }
    if (diff < 300) {
      format = "m分s秒";
    }
    if (diff < 60) {
      format = "s秒";
    }
    return dayjs.unix(diff).utc().format(format);
  }
  return "00:00:00";
};
export default function LiveBefore(_ref) {
  let {
    watch,
    state,
    isChatAvailableMeta,
    setChatDisplay
  } = _ref;
  const calculateTimeLeft = useCallback(() => {
    const now = dayjs();
    const startDate = dayjs(new Date(watch.episode.delivery_start_at));
    return startDate.diff(now, "seconds");
  }, []);
  const {
    0: timeLeft,
    1: setTimeLeft
  } = useState(calculateTimeLeft());
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  });
  useEffect(() => {
    if (timeLeft <= 0) {
      state.reset();
    }
  }, [timeLeft]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.livebefore,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: "\u914D\u4FE1\u307E\u3067"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.timeleft,
        children: formatCountDown(timeLeft)
      })]
    }), isChatAvailableMeta && /*#__PURE__*/_jsx(Button, {
      fillColor: true,
      medium: true,
      onClick: () => setChatDisplay(true),
      children: "\u30C1\u30E3\u30C3\u30C8\u8868\u793A"
    })]
  });
}